import { Injectable } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

import { SpecialValidators } from 'ish-shared/forms/validators/special-validators';

import { FieldLibraryConfiguration } from './field-library-configuration';

/**
 * Company Name 1, required by default
 */
@Injectable()
export class CompanyName1Configuration extends FieldLibraryConfiguration {
  id = 'companyName1';

  getFieldConfig(): FormlyFieldConfig {
    return {
      type: 'ish-text-input-field',
      props: {
        label: 'account.address.company_name.label',
        required: true,
        maxLength: 60,
      },
      validators: {
        validation: [SpecialValidators.noOnlyWhiteSpaces],
      },
      validation: {
        messages: {
          required: 'account.address.company_name.error.required',
          noOnlyWhiteSpaces: 'account.address.company_name.error.required',
        },
      },
    };
  }
}
